import { TypePolicies } from '@apollo/client'

export const typePolicies: TypePolicies = {
    Category: {
        keyFields: ['uuid'],
    },
    Product: {
        keyFields: ['uuid'],
    },
    ProductVariant: {
        keyFields: ['uuid'],
    },
    Container: {
        keyFields: ['uuid'],
    },
    Topping: {
        keyFields: ['uuid'],
    },
    RemovedRecipeIngredients: {
        keyFields: ['uuid'],
    },
    Cart: {
        keyFields: ['key'],
        fields: {
            items: {
                merge: false,
            },
            containerItems: {
                merge: false,
            },
        },
    },
    CartContainerItem: {
        keyFields: ['uuid'],
    },
    CartItem: {
        keyFields: ['uuid'],
        fields: {
            toppingGroupToppings: {
                merge: false,
            },
            additionGroupProductVariants: {
                merge: false,
            },
            removedRecipeIngredients: {
                merge: false,
            },
        },
    },
    OpenTab: {
        keyFields: ['uuid'],
        fields: {
            items: { merge: false },
            submissions: { merge: false },
            settlements: { merge: false },
        },
    },
    OpenTabItem: {
        keyFields: ['uuid'],
        fields: {
            addedProductVariants: { merge: false },
            removedRecipeIngredients: { merge: false },
            toppings: { merge: false },
        },
    },
    OpenTabSubmission: {
        keyFields: ['uuid'],
        fields: {
            items: { merge: false },
        },
    },
    OpenTabSettlement: {
        keyFields: ['uuid'],
        fields: {
            items: { merge: false },
        },
    },
    OpenTabSettlementItem: {
        keyFields: ['uuid'],
    },
    OrderDraft: {
        keyFields: [],
    },
    DeliverableLocationEvaluationResult: {
        keyFields: [],
    },
    NonDeliverableLocationEvaluationResult: {
        keyFields: [],
    },
}
